import { Routes } from "@angular/router";
import { MakereviewComponent } from "src/app/reviews/makereview/makereview.component";
import { ReviewsComponent } from "src/app/reviews/reviews/reviews.component";

export const REVIEW_ROUTES: Routes = [
   {
      path: 'reviews/make/:id', component: MakereviewComponent
   },
   {
      path: 'reviews/:id', component: ReviewsComponent
   }
]